import { baseColors } from "@Constants/baseStyles"
import React from "react"
import { Dimensions, View } from "react-native"
import {
    LineChart,
    BarChart,
    PieChart,
    ProgressChart,
    ContributionGraph,
    StackedBarChart
} from "react-native-chart-kit"

const { width, height } = Dimensions.get("screen")
export const ChartCard = (props) => {
    return (
        <View
            style={{
                backgroundColor: baseColors.green.light,
                justifyContent: "center",
                padding: 20,
                alignContent: "center",
                alignItems: "center",
                borderRadius: 10
            }}
        >
            <BarChart
                data={{
                    labels: ["01/11", "02/11", "03/11", "04/11", "05/11"],
                    datasets: [
                        {
                            data: [
                                Math.random() * 100,
                                Math.random() * 100,
                                Math.random() * 100,
                                Math.random() * 100,
                                Math.random() * 100
                            ]
                        }
                    ]
                }}
                width={width} // from react-native
                height={220}
                yAxisInterval={1} // optional, defaults to 1
                fromZero
                chartConfig={{
                    
                    backgroundColor: baseColors.green.light,
                    backgroundGradientFrom: baseColors.green.light,
                    backgroundGradientTo: baseColors.green.light,
                    decimalPlaces: 2, // optional, defaults to 2dp
                    color: (opacity = 1) => baseColors.green.primary,
                    labelColor: (opacity = 1) => baseColors.black,
                    barPercentage: 0.3,
                    style: {
                        borderRadius: 10,
                        margin: 5,
                        backgroundColor: "red"
                    }
                }}
                style={{
                    borderRadius: 10,
                    margin: 10
                }}
                
            />
        </View>
    )
}
